import { Component, OnInit } from '@angular/core';
import {NbDialogRef} from "@nebular/theme";

@Component({
    selector: 'ngx-final-report-info',
    templateUrl: './final-report-info.component.html',
    styleUrls: ['./final-report-info.component.scss'],
})
export class FinalReportInfoComponent implements OnInit {

    constructor(
        protected dialogRef: NbDialogRef<any>
    ) { }

    // tslint:disable-next-line:no-empty
    ngOnInit(): void {
    }

    public close(): void{

        this.dialogRef.close();
    }

}
